var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4481 10.8944C17.6139 10.8113 17.7534 10.6836 17.8509 10.5258C17.9484 10.3679 18 10.186 18 10.0004C18 9.81488 17.9484 9.63299 17.8509 9.47511C17.7534 9.31722 17.6139 9.18957 17.4481 9.10643L3.44807 2.10643C3.27448 2.01958 3.07936 1.98512 2.88653 2.00726C2.69369 2.0294 2.51146 2.10719 2.36208 2.23113C2.21269 2.35507 2.10261 2.5198 2.04525 2.70524C1.9879 2.89068 1.98575 3.0888 2.03907 3.27543L3.46807 8.27543C3.52784 8.48441 3.65407 8.66822 3.82765 8.79904C4.00123 8.92985 4.21271 9.00056 4.43007 9.00043L9.00107 9.00043C9.26628 9.00043 9.52064 9.10579 9.70817 9.29333C9.89571 9.48086 10.0011 9.73522 10.0011 10.0004C10.0011 10.2657 9.89571 10.52 9.70817 10.7075C9.52064 10.8951 9.26628 11.0004 9.00107 11.0004H4.43007C4.21271 11.0003 4.00123 11.071 3.82765 11.2018C3.65407 11.3326 3.52784 11.5165 3.46807 11.7254L2.04007 16.7254C1.98664 16.912 1.98866 17.1101 2.04588 17.2956C2.1031 17.481 2.21305 17.6458 2.36232 17.7698C2.51159 17.8939 2.69372 17.9718 2.88652 17.9941C3.07931 18.0164 3.27442 17.9821 3.44807 17.8954L17.4481 10.8954V10.8944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtn);
export default __webpack_public_path__ + "static/media/arrowBtn.e6add2934a8b60cdedd2569bec5d6df3.svg";
export { ForwardRef as ReactComponent };